export const actionTypes = {
  REQUEST_START: 'MY_TAXES.ADMINISTRATIVE_FINES.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'MY_TAXES.ADMINISTRATIVE_FINES.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'MY_TAXES.ADMINISTRATIVE_FINES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MY_TAXES.ADMINISTRATIVE_FINES.REQUEST_FAILURE',
  REQUEST_START_EXISTING: 'MY_TAXES.ADMINISTRATIVE_FINES.REQUEST_START_EXISTING',
  REQUEST_SUCCESS_EXISTING: 'MY_TAXES.ADMINISTRATIVE_FINES.REQUEST_SUCCESS_EXISTING',
  FETCH_ADM_FILTERS_START: 'MY_TAXES.ADMINISTRATIVE_FINES.FETCH_ADM_FILTERS_START',
  FETCH_ADM_FILTERS_SUCCESS: 'MY_TAXES.ADMINISTRATIVE_FINES.FETCH_ADM_FILTERS_SUCCESS',
  FETCH_ADM_FILTERS_FAILURE: 'MY_TAXES.ADMINISTRATIVE_FINES.FETCH_ADM_FILTERS_FAILURE',
};

export function startRequest(filters) {
  return {
    type: actionTypes.REQUEST_START,
    payload: filters,
  };
}

export function startRequestExisting() {
  return {
    type: actionTypes.REQUEST_START_EXISTING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestSuccessExisting(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS_EXISTING,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function startAdmFiltersRequest() {
  return {
    type: actionTypes.FETCH_ADM_FILTERS_START,
  };
}
export function successAdmFiltersRequest(data) {
  return {
    type: actionTypes.FETCH_ADM_FILTERS_SUCCESS,
    payload: data,
  };
}
export function failureAdmFiltersRequest() {
  return {
    type: actionTypes.FETCH_ADM_FILTERS_FAILURE,
  };
}
